/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const AssignmentCompleteIcon = /*#__PURE__*/ createSvgIcon(
  'AssignmentCompleteIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 19.167A9.167 9.167 0 1010 .834a9.167 9.167 0 000 18.333zm3.602-12.313l-5.297 5.297-2.219-2.234a.608.608 0 00-.445-.188.608.608 0 00-.445.188.637.637 0 00-.196.445.582.582 0 00.18.445l2.688 2.688a.6.6 0 00.437.187.6.6 0 00.438-.187l5.734-5.75a.608.608 0 00.188-.446.608.608 0 00-.188-.445.6.6 0 00-.438-.187.6.6 0 00-.437.187z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default AssignmentCompleteIcon;
